import { withInstall as o } from "../../utils/with-install.js";
import t from "./dialog.vue.js";
/* empty css            */
const p = o(t);
export {
  p as ApDialog
};
